import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-listremove-item"
export default class extends Controller {

  remove(event) {
    event.preventDefault()
    
    // Remove the entire wrapper element which contains both the input and turbo-frame
    this.element.remove()
  }
}
